export * from "./parameters.js";
export * from "./preprocessing.js";
export * from "./api.js";
export * from "./shifts.js";
export * from "./pumps.js";
export * from "./lubrication.js";
export * from "./jackingForce.js";
export * from "./drawingAnalyze.js";
export * from "./diary.js";
export * from "./pipes.js";
export * from "./alerts.js";
export * from "./slurry.js";

import { PRIMARY_REFERENCE_IDS } from "./parameters.js";
import { PUMP_REFERENCE_IDS } from "./pumps.js";
import { ALERT_SENSOR_REFERENCE_IDS } from "./alerts.js";

/**
 * Reference IDs the fetch worker pulls from Herrenknecht via /values.
 * Bentonite data does NOT come through here — it's fetched separately by
 * the Bentonite worker against /api/v3/Bentonite/values, which is a
 * report endpoint with its own schema (see lubrication.ts).
 */
export const INGESTED_REFERENCE_IDS: string[] = [
  // De-duplicated: an alert or pump id can also appear in the primary
  // set. Without the Set the worker sent the same `id=` twice on every
  // /values request and ran upsertSensorValues twice for the sensor.
  ...new Set([
    ...PRIMARY_REFERENCE_IDS,
    ...PUMP_REFERENCE_IDS,
    ...ALERT_SENSOR_REFERENCE_IDS,
  ]),
];
